import * as Yup from "yup";

export const ChequeAddFormValidation = Yup.object({});
